<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}">
    <div class="subBlockContent" id="addProduct">
        <child-header [title]="title" (click)="close()" ></child-header>

        <div #ParentWrapper class="child-body">
            <div class="inner-subBlock-wrapper">
                <div class="d-flex" style="justify-content: normal;margin-bottom: 2em;">
                    <button class="button button-red btn-csp mr-2" [class.active]="productType==='Azure'" (click)="changeProductType('Azure')"> Azure</button>
                    <button class="button button-red btn-csp mr-2" [class.active]="productType==='OnlineService'" (click)="changeProductType('OnlineService')"> Online
                        Service</button>
                    <button class="button button-red btn-csp mr-2" [class.active]="productType==='Software'" (click)="changeProductType('Software')">
                        Software</button>
                    <!--
                    <button class="button button-red btn-csp" (click)="confirmProduct()">
                        Confirm Products</button> -->
                </div>

                <ng-container *ngIf="productType ==='Azure' || productType === 'Reservations'">

                    <div class="row">

                        <div class="listpart col-md-6">
                            <ng-select class="customDropdwon" [items]="azureItemList" bindValue="value" bindLabel="displayText" placeholder="Type: Please Select" [(ngModel)]="azureType" (ngModelChange)="changeAzureType($event)">
                            </ng-select>
                        </div>

                        <div class="listpart col-md-6" *ngIf="azureType==='Reservations'">
                            <ng-select class="customDropdwon" [items]="azureReservationItemList" bindValue="value" bindLabel="displayText" placeholder="Reservations Type: Please Select" [(ngModel)]="azureReservationType" (ngModelChange)="changeAzureReservationType($event)">
                            </ng-select>
                        </div>

                    </div>

                    <!--location usage subscriotion and payment frequency drop downs-->
                    <div class="row">

                        <ng-container *ngIf="(azureType==='Reservations') && azureReservationType">

                            <div class="listpart col-md-12">
                                <!-- <mat-form-field class="usagesub">
                                <mat-select placeholder="Please select usage subscription" (change)="selectUsageSubscription($event)">
                                    <mat-option *ngFor="let item of azureRiUsageSubscriptionList?.selectItemList" [value]="item?.value">
                                    {{item?.text}}
                                    </mat-option>
                                </mat-select>
                                </mat-form-field> -->
                                <ng-select class="customDropdwon" [items]="azureRiUsageSubscriptionList?.selectItemList" bindValue="value" bindLabel="text" placeholder="Please select usage subscription" [(ngModel)]="selectedSubscriptionItem" (change)="selectUsageSubscription()">
                                </ng-select>
                            </div>
                            <!-- <div class="listpart col-md-6">
                                <ng-select class="customDropdwon" [items]="mpnList" bindValue="mpn" bindLabel="mpn" placeholder="Select / Enter New MPN ID" [(ngModel)]="azureRiMpnIdSelect">
                                </ng-select>
                            </div> -->
                            <div class="listpart col-md-12">
                                <ng-select [disabled]="disableLocationandPaymentFrenq()" class="customDropdwon" [items]="locationList" bindValue="locationName" bindLabel="locationName" placeholder="Select Location" [(ngModel)]="selectedLocation" (change)="selectLocation()">
                                </ng-select>
                            </div>

                            <div class="listpart col-md-12">
                                <ng-select [disabled]="disableLocationandPaymentFrenq()" [loading]="azureRiDurationLoading" class="customDropdwon" [items]="paymentFreqList" bindValue="value" bindLabel="value" placeholder="Payment frequency" [clearable]="false" [(ngModel)]="selectedPaymentFreq" (change)="selectPaymentFrequency()"></ng-select>
                            </div>

                            <div class="listpart col-md-12">
                                <ng-select [disabled]="disableLocationandPaymentFrenq()" [loading]="azureRiDurationLoading" class="customDropdwon" [items]="scopeList" bindValue="value" bindLabel="value" placeholder="Scope" [clearable]="false" [(ngModel)]="selectedScope"></ng-select>
                            </div>

                            <div class="listpart div-seach">
                                <div class="searchInputGroup">
                                    <div class="searchIcon">
                                        <img src="../images/new_ui/filter.png">
                                    </div>
                                    <input class="searchInput" type="text" #searchValue placeholder="Filter" [(ngModel)]="searchAzureRi" (ngModelChange)="filterAzureRiItems()">
                                </div>
                            </div>
                            
                        </ng-container>

                    </div>

                </ng-container>

                <ng-container *ngIf="productType === 'OnlineService'">

                    <div class="row">
                        <div class="listpart col-md-6">
                            <ng-select class="customDropdwon" [items]="cspItemList" bindValue="value" bindLabel="displayText" placeholder="Subscription Type" [(ngModel)]="selectedSubscriptionType" (ngModelChange)="changeSubscriptionType($event)">
                            </ng-select>
                        </div>
                        <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20" style="position: relative;top:15px" *ngIf="isLoadingListView">
                        </mat-spinner>
                    </div>

                    <div class="row filter-wrapper">
                        <div class="searchInputGroup" style="width: auto;margin-left:10px;">
                            <div class="searchIcon">
                                <img src="../images/new_ui/filter.png">
                            </div>
                            <input class="searchInput" type="text" #searchValue placeholder="Filter" [(ngModel)]="searchSubscriotion" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" (ngModelChange)="filterSubscriptionItems()">
                        </div>

                        <!-- # brand filter -->
                        <div class="listpart col-md-6" style="margin-right: 10px;">
                        </div>
                    </div>


                </ng-container>

                <ng-container *ngIf="productType === 'Software'">

                    <div class="row">

                        <div class="listpart col-md-6">

                            <ng-select class="customDropdwon" [items]="softwareItemList" bindValue="value" bindLabel="displayText" placeholder="Software Type: Please Select" [(ngModel)]="softwareType" (ngModelChange)="changeSoftwareType($event)">
                            </ng-select>

                        </div>

                        <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20" style="position: relative;top:15px" *ngIf="isLoadingListView">
                        </mat-spinner>
                    </div>

                    <!-- payment freq (only for software subs) -->
                    <!-- <div class="row" *ngIf="softwareType == 'SOFT'">
                        <div class="listpart col-md-6">
                            <ng-select
                                class="customDropdwon"
                                bindValue="value"
                                placeholder="Payment frequency"
                                bindLabel="value"
                                [items]="paymentFreqList"
                                [loading]="isLoadingContent"
                                [disabled]="isLoadingContent"
                                [clearable]="false"
                                [(ngModel)]="selectedSoftSubPaymentFreq"
                                (change)="proccessSoftwareSubsList()"
                            >
                            </ng-select>
                        </div>
                    </div> -->

                    <div class="row filter-wrapper">

                        <div class="searchInputGroup" style="width: auto;margin-left:10px;">
                            <div class="searchIcon">
                                <img src="../images/new_ui/filter.png">
                            </div>
                            <input class="searchInput" type="text" #searchValue placeholder="Filter" [(ngModel)]="searchSoftwareSubscription" (ngModelChange)="filterSoftwareSubscriptionItems()">
                        </div>

                        <!-- # brand filter -->
                        <div class="listpart col-md-6" style="margin-right: 10px;">
                        </div>
                    </div>

                </ng-container>

                <!-- show add-on toggle -->
                <ng-container *ngIf="productType=='OnlineService' && (selectedSubscriptionType=='85NB' || selectedSubscriptionType=='85NA' || selectedSubscriptionType=='85NC')">
                    <div class="row">                           
                        <div class="column" style="margin-left:15px;">                            
                        Show Add-On &nbsp;
                        <mat-slide-toggle (change)="showAddOn($event)" [checked]="isAddOn">
                        </mat-slide-toggle>&nbsp;
                        </div>
                    </div>                                             
                </ng-container>

                <!--  -->
                <ng-container *ngIf="isLoadingContent">
                    <div class="row mt-2" style="margin-left:0px;">
                        <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20">
                        </mat-spinner>
                        <label class="noData-label ml-1 mt-1">
                            {{pendingMessage}}
                        </label>
                    </div>
                </ng-container>

                <loading-screen *ngIf="!loadContent || isLoadingContent" [showBlurTable]="true">
                </loading-screen>
                
                <div *ngIf="loadContent">
                    <!--Azure-->
                    <ng-container *ngIf="productType==='Azure'||productType==='Reservations'">

                        <!-- Microsoft Azure -->

                        <ng-container *ngIf="azureType==='Microsoft Azure'">

                            <div class="col-md-12 align-center" *ngIf="!annuityItems?.length && !isLoadingContent">
                                <label class="noData-label">
                                    There is no eligible offers found
                                </label>
                            </div>
                            
                            <div class="x-margin-top" *ngIf="annuityItems?.length && !isLoadingContent">
                                <div class="mTable">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col" class="align-left" style="width: 60%">DESCRIPTION</th>
                                                <th scope="col" class="align-right" style="width: 20%; text-align: right;">
                                                    PRICE
                                                </th>
                                                <th scope="col" class="align-center" style="width: 10%">QTY</th>
                                                <th scope="col" class="align-center" style="width: 10%"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let annuityItem of annuityItems">
                                                <td>
                                                    <span class="description-popup">{{annuityItem?.description}}</span>
                                                    <span class="trial" *ngIf="annuityItem?.chargeType == 'TRIAL'">{{annuityItem?.chargeType}}</span>
                                                    <div class="result-info">
                                                        <div class="produc-secondary-title-wrapper">
                                                            <span class="light-text">STOCK CODE:&nbsp;</span>
                                                            <span>{{annuityItem?.stockCode}}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="align-right" style="position: relative;vertical-align: middle;text-align: right;">
                                                    {{annuityItem?.itemPrice}}
                                                    <span *ngIf="annuityItem?.billingFrequency == '1'">/mth</span>
                                                    <span *ngIf="annuityItem?.billingFrequency == 'Y'">/yr</span>
                                                </td>
                                                <td class="align-center" style="position: relative;vertical-align: middle;">
                                                    <input class="align-center input-wrapper input-wrapper-small" [disabled]="annuityItem.disableQty" [(ngModel)]="annuityItem.quantity" (keypress)="_keyPress($event)" type="text" (blur)="changeQty(annuityItem)">
                                                    <mat-icon matSuffix class="editmpnidicon align-top" *ngIf="annuityItem?.minMaxQtyText" placement="bottom" ngbTooltip="{{annuityItem?.minMaxQtyText}}">info</mat-icon>
                                                </td>
                                                <td class="align-center" style="vertical-align: middle;">
                                                    <!-- <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton" *ngIf="!annuityItem?.isExisting && !isHiddenAddButton()" (click)="addAnnuityItem(annuityItem)">Add</button> -->
                                                    <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton" *ngIf="!isHiddenAddButton()" (click)="addAnnuityItem(annuityItem)">Add</button>
                                                    <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton" *ngIf="annuityItem?.isExisting" (click)="addAnnuityItem(annuityItem)">Update</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </ng-container>

                        <!-- Azure RI -->

                        <ng-container *ngIf="(azureType==='Reservations') && azureReservationType">
                            <div class="x-margin-top" *ngIf="azureRiList?.length&&!isLoadingContent">
                                <div class="mTable">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col" class="align-left" style="width: 20%">STOCK CODE</th>
                                                <th scope="col" class="align-left" style="width: 45%">TITLE</th>
                                                <th scope="col" class="align-right" style="width: 10%">PRICE</th>
                                                <th scope="col" class="align-center" style="width: 15%">QUANTITY</th>
                                                <th scope="col" class="align-center" style="width: 10%"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let software of azureRiListFilter">
                                                <td class="align-left" style="position: relative;vertical-align: middle; text-align: left">
                                                    {{software?.productId+":"+software?.skuId}}
                                                </td>
                                                <td style="position: relative;vertical-align: middle;">
                                                    <span class="description-popup">{{software?.description}}</span>
                                                </td>
                                                <td class="align-right" style="position: relative;vertical-align: middle;">
                                                    <span *ngIf="!isMonthlyPayment">{{software?.itemPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                                                    <span *ngIf="isMonthlyPayment">{{software?.monthlyPrice | currency:'AUD':'symbol-narrow':'.2-2'}}/mth</span>
                                                </td>
                                                <td class="align-center" style="position: relative;vertical-align: middle;">
                                                    <input class="align-center align-top input-wrapper input-wrapper-small" [(ngModel)]="software.quantity" type="text">
                                                    <mat-icon matSuffix *ngIf="software?.minMaxQtyText" class="editmpnidicon align-top" placement="bottom" ngbTooltip="{{software?.minMaxQtyText}}">info</mat-icon>
                                                </td>
                                                <td class="align-center" style="vertical-align: middle;">
                                                    <button id="{{software?.productId+'_'+software?.skuId}}" class="button button-red button-mid confirmbutton" (click)="addAzureRiItem(software)" >Add</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="button-center">
                                <button *ngIf="azureRiList?.length && !isLoadingContent" class="button button-red button-large button-center-right" (click)="finishAddAzureRi()">Continue</button>
                            </div>

                        </ng-container>

                    </ng-container>


                    <!--Online Service-->
                    <ng-container *ngIf="productType==='OnlineService'">

                        <div class="col-md-12 align-center" *ngIf="!subscriptionItems?.length && !isLoadingContent">
                            <label class="noData-label">
                                <!-- We couldn’t find any annuity items -->
                            </label>
                        </div>

                        <div class="x-margin-top"  *ngIf="subscriptionItems?.length && !isLoadingContent"  >
                            <div class="mTable">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col" class="align-left" style="width: 60%">DESCRIPTION</th>
                                            <th scope="col" class="align-right" style="width: 15%; text-align: right;">PRICE</th>
                                            <th scope="col" class="align-right" style="width: 15%; text-align: right;">RRP</th>
                                            <th scope="col" class="align-center" style="width: 10%">QTY</th>
                                            <th scope="col" class="align-center" style="width: 10%"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                       <!-- <span  class="description-popup">{{annuityItem?.description}}
                                         <span *ngIf="annuityItem.isAddon" class="nce">ADD-ON</span></span>-->
                                    
                                         <tr *ngFor="let annuityItem of subscriptionItemsFilter">
                                            <ng-container ngSwitch[]="isAddOn">
                                            <ng-container *ngIf="!annuityItem.isAddon && isAddOn==false" >
                                        <td>
                                            <span  class="description-popup">{{annuityItem?.description}}</span>
                                            <span class="trial" *ngIf="annuityItem?.chargeType == 'TRIAL'">{{annuityItem?.chargeType}}</span>                                                                                                                                
                                            <div class="result-info">
                                                <div class="produc-secondary-title-wrapper">
                                                    <span class="light-text">STOCK CODE:&nbsp;</span>
                                                    <span >{{annuityItem?.stockCode}}</span>
                                                </div>
                                            </div>
                                         </td>                             
                                                                                                          
                                        <td  class="align-right" style="position: relative;vertical-align: middle;text-align: right;">
                                            {{annuityItem?.itemPrice}}
                                            <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P1M'">/mth</span>
                                            <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P1Y'">/yr</span>
                                            <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P3Y'">/3yr</span>
                                        </td>

                                        <td  class="align-right" style="position: relative;vertical-align: middle;text-align: right;">
                                            {{annuityItem?.itemRRPrice}}
                                            <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P1M'">/mth</span>
                                            <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P1Y'">/yr</span>
                                            <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P3Y'">/3yr</span>
                                        </td>

                                        <td class="align-center" style="position: relative;vertical-align: middle;">
                                            <input class="align-center input-wrapper input-wrapper-small"  [(ngModel)]="annuityItem.quantity" (keypress)="_keyPress($event)" type="text" (blur)="changeQty(annuityItem)">
                                            <mat-icon matSuffix class="editmpnidicon align-top" *ngIf="annuityItem?.minMaxQtyText" placement="bottom" ngbTooltip="{{annuityItem?.minMaxQtyText}}">info</mat-icon>
                                        </td>
                                        <td class="align-center" style="vertical-align: middle;">
                                            <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton" *ngIf="!annuityItem?.isExisting" (click)="addSubscriptionItem(annuityItem)">Add</button>
                                            <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton" *ngIf="annuityItem?.isExisting" (click)="addSubscriptionItem(annuityItem)">Update</button>
                                        </td>
                                    </ng-container>
                                </ng-container>
                                <ng-container ngSwitch[]="!isAddOn">
                                    <ng-container *ngIf="annuityItem.isAddon && isAddOn==true" >
                                   <td>                                        
                                    <span  class="description-popup">{{annuityItem?.description}}
                                    <span class="trial" *ngIf="annuityItem?.chargeType == 'TRIAL'">{{annuityItem?.chargeType}}</span>
                                    <span *ngIf="annuityItem.isAddon" class="nce">ADD-ON</span></span>                                                                                  
                                    <div class="result-info">
                                        <div class="produc-secondary-title-wrapper">
                                            <span class="light-text">STOCK CODE:&nbsp;</span>
                                            <span >{{annuityItem?.stockCode}}</span>
                                        </div>
                                    </div>
                                 </td>                                      
                                                                                                          
                                <td  class="align-right" style="position: relative;vertical-align: middle;text-align: right;">
                                    {{annuityItem?.itemPrice}}
                                    <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P1M'">/mth</span>
                                    <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P1Y'">/yr</span>
                                    <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P3Y'">/3yr</span>
                                </td>
                                <td  class="align-right" style="position: relative;vertical-align: middle;text-align: right;">
                                    {{annuityItem?.itemRRPrice}}
                                    <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P1M'">/mth</span>
                                    <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P1Y'">/yr</span>
                                    <span *ngIf="annuityItem?.stockCode.split(':')[0] == 'P3Y'">/3yr</span>
                                </td>
                                <td class="align-center" style="position: relative;vertical-align: middle;">
                                    <input class="align-center input-wrapper input-wrapper-small"  [(ngModel)]="annuityItem.quantity" (keypress)="_keyPress($event)" type="text" (blur)="changeQty(annuityItem)">
                                    <mat-icon matSuffix class="editmpnidicon align-top" *ngIf="annuityItem?.minMaxQtyText" placement="bottom" ngbTooltip="{{annuityItem?.minMaxQtyText}}">info</mat-icon>
                                </td>
                                <td class="align-center" style="vertical-align: middle;">
                                    <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton" *ngIf="!annuityItem?.isExisting" (click)="addSubscriptionItem(annuityItem)">Add</button>
                                    <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton" *ngIf="annuityItem?.isExisting" (click)="addSubscriptionItem(annuityItem)">Update</button>
                                </td>                                
                                </ng-container>
                            </ng-container>
                             </tr>
                          </tbody>
                        </table>
                        </div>
                        <div class="button-center">
                            <button *ngIf="annuityItems?.length && loadContent" class="button button-red button-large" (click)="finishAddSubscriotions()">Continue</button>
                        </div>
                    </div>

                </ng-container>




                    <!--Software-->
                    <ng-container *ngIf="productType==='Software'">

                        <div class="row x-margin-top">

                            <div class="col-md-12 align-center" *ngIf="!softwareSubscriptionAddItems?.length && !isLoadingContent && !(softwareType==null)">
                                <label class="noData-label">
                                    We couldn’t find any perpetual item
                                </label>
                            </div>

                            <div class="col-md-12" *ngIf="softwareSubscriptionAddItems?.length && !isLoadingContent">
                                <div class="mTable">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col" class="align-left" style="width: 20%">STOCK CODE</th>
                                                <th scope="col" class="align-left" style="width: 50%">TITLE</th>
                                                <th scope="col" class="align-center" style="width: 10%">PRICE</th>
                                                <th scope="col" class="align-center" style="width: 10%">QUANTITY</th>
                                                <th scope="col" class="align-center" style="width: 10%"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let software of softwareSubscriptionAddItemsFilter">
                                                <td class="align-center" style="position: relative;vertical-align: middle; text-align: left">
                                                    {{software?.stockCode}}
                                                </td>
                                                <td style="position: relative;vertical-align: middle;">
                                                    <span class="description-popup">{{software?.title}}</span>
                                                </td>
                                                <td class="align-right" style="position: relative;vertical-align: middle;">
                                                    <span *ngIf="selectedSoftSubPaymentFreq == 'Upfront'">{{software?.itemPrice}}</span>
                                                    <span *ngIf="selectedSoftSubPaymentFreq == 'Monthly'">{{software?.monthlyPrice | currency:'AUD':'symbol-narrow':'.2-2'}}/mth</span>
                                                </td>
                                                <td class="align-center" style="position: relative;vertical-align: middle;">
                                                    <input class="align-center input-wrapper input-wrapper-small" [(ngModel)]="software.quantity" type="text">
                                                    <mat-icon matSuffix *ngIf="software?.minMaxQtyText" class="editmpnidicon align-top" placement="bottom" ngbTooltip="{{software?.minMaxQtyText}}">info</mat-icon>
                                                </td>
                                                <td class="align-center" style="vertical-align: middle;">
                                                    <button class="button button-red button-mid confirmbutton" id="{{software?.stockCode.replace(':', '_')}}" *ngIf="!software?.isExisting" (click)="addSoftwareSubscription(software)" [disabled]="!checkMpnId">Add</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="button-center">
                                    <button *ngIf="softwareSubscriptionAddItems?.length && loadContent" class="button button-red button-large saveuser" (click)="finishAddSoftware()">Continue</button>
                                </div>
                            </div>

                        </div>

                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="showSideBar">
        <div style="margin-left: 1px;" class="subBlockContent" id="addProductSideBar">
            <child-header [title]="title" (closeEvent)="closeSideBar()"></child-header>
            <div class="child-body">
                <div class="inner-subBlock-wrapper">
                    <ng-container>
                        <div *ngIf="(productType==='Reservations'&& azureType ==='Reservations')">
                            <div class="searchInputGroup" style="width: 186px;margin:auto;margin-bottom: 15px;">
                                <div class="searchIcon search-carts">
                                    <img src="../images/new_ui/filter.png">
                                </div>
                                <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                                    onblur="this.placeholder='Filter'" [(ngModel)]="sideBarAzureRiSearch">
                            </div>
                            <ng-container *ngFor="let item of azureRIItemsPendingList;index as i">
                                <ng-container *ngIf="item.title.toLowerCase().includes(sideBarAzureRiSearch.toLowerCase())">
                                    <div class="menu-wrapper menu-wrapper-position">
                                        <div class="total-div pr-2">
                                            <div class="narrow-title">{{item.title}}</div>
                                            <span class="narrow-text">Price:{{item.isMonthly?item.monthlyPrice+'/mth':item.itemPrice}} |
                                                Quantity:
                                                {{item.quantity}}</span>
                                        </div>
                                        <div class="icon">
                                            <span class="basic-icon delete-icon information-icon-position"
                                                ngbTooltip="Remove" (click)="removeAzureRIItemsPending(i)"></span>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <div class="align-center mt-3">
                                <button class="button button-red button-mid btn-csp"
                                    [disabled]="azureRIItemsPendingList.length==0"
                                    (click)="confirmProduct()">Confirm</button>
                            </div>
                        </div>
                        <div *ngIf="productType==='OnlineService'||(productType==='Azure'&&azureType==='Microsoft Azure')">
                            <div class="searchInputGroup" style="width: 186px;margin:auto;margin-bottom: 15px;">
                                <div class="searchIcon search-carts">
                                    <img src="../images/new_ui/filter.png">
                                </div>
                                <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                                    onblur="this.placeholder='Filter'" [(ngModel)]="sideBarSubscriptionSearch">
                            </div>
                            <ng-container *ngFor="let item of subscriptionItemsPendingList;index as i">
                                <ng-container
                                    *ngIf="item.description.toLowerCase().includes(sideBarSubscriptionSearch.toLowerCase())">
                                    <div class="menu-wrapper menu-wrapper-position">
                                        <div class="total-div pr-2">
                                            <div class="narrow-title">{{item.description}}</div>
                                            <span class="narrow-text">Price:{{item.itemPrice}}  
                                                <span *ngIf="item?.stockCode.split(':')[0] == 'P1M'">/mth</span>
                                                <span *ngIf="item?.stockCode.split(':')[0] == 'P1Y'">/yr</span>
                                                <span *ngIf="item?.stockCode.split(':')[0] == 'P3Y'">/3yr</span> |
                                                Quantity:
                                                {{item.quantity}}</span>
                                        </div>
                                        <div class="icon">
                                            <span class="basic-icon delete-icon information-icon-position"
                                                ngbTooltip="Remove" (click)="removeSubscriptionPendingItem(i)"></span>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <div class="align-center mt-3">
                                <button class="button button-red button-mid btn-csp"
                                    [disabled]="subscriptionItemsPendingList.length==0"
                                    (click)="confirmProduct()">Confirm</button>
                            </div>
                        </div>
                        <div *ngIf="productType==='Software'">

                            <div class="searchInputGroup" style="width: 186px;margin:auto;margin-bottom: 15px;">
                                <div class="searchIcon search-carts">
                                    <img src="../images/new_ui/filter.png">
                                </div>
                                <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                                    onblur="this.placeholder='Filter'" [(ngModel)]="sideBarSoftwareSearch" >
                            </div>

                            <ng-container *ngFor="let item of softwareSubscriptionPendingList;index as i">

                                <ng-container
                                    *ngIf="item.title.toLowerCase().includes(sideBarSoftwareSearch.toLowerCase())">
                                    <div class="menu-wrapper menu-wrapper-position">
                                        <div class="total-div pr-2">
                                            <div class="narrow-title">{{item.title}}</div>
                                         <span *ngIf="!item.isMonthly" class="narrow-text">Price: {{item.itemPrice}} |
                                                Quantity:
                                                {{item.quantity}}</span>
                                        <span *ngIf="item.isMonthly" class="narrow-text">Price: {{item.monthlyPrice | currency:'AUD':'symbol-narrow':'.2-2'}}/mth |
                                            Quantity:
                                            {{item.quantity}}</span>
                                        </div>
                                        <div class="icon">
                                            <span class="basic-icon delete-icon information-icon-position"
                                                ngbTooltip="Remove"
                                                (click)="removeSoftwareSubscriptionPendingList(i)"></span>
                                        </div>
                                    </div>
                                </ng-container>

                            </ng-container>
                            <div class="align-center mt-3">
                                <button class="button button-red button-mid btn-csp"
                                    [disabled]="softwareSubscriptionPendingList.length==0"
                                    (click)="confirmProduct()">Confirm</button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>

    <router-outlet></router-outlet>
</div>
